export enum HorizontalAlignment {
	Start = 'start',
	Center = 'center',
	End = 'end',
	Hidden = 'hidden',
}
